<div class="home-center">
    <div class="orient reverse" style="align-items: center; align-items: start;">
        <div class="logo">

            <button type="button" (click)="fileInput.click()" class="edit">
                <img src="assets/images/Edit.svg" style="object-fit: contain; max-width: 100%;"/>
                <input #fileInput type="file" (change)="onChange($event)" style="display:none;" accept="image/*" />                
            </button>
        </div>
        <div>
            <h2>Your Company's Logo</h2>
            <h4>Upload your company logo that will be shown to users.</h4>
            <small>This will be displayed in a 186x80 window. JPG, PNG, etc.</small>
        </div>
    </div>
    <div class="flex-row" style="gap: 16px; justify-content: space-between; width: 100%;" *ngIf="config !== undefined">
        <div class="flex-col" style="gap: 2px;">
            <span>Header Colour</span>
            <div class="colour-container">
                <p-colorPicker ngDefaultControl [(ngModel)]="config.headerColour"></p-colorPicker>
                <input [(ngModel)]="config.headerColour" type="text" pInputText style="width: 100px;"> 
            </div>
            <small>Hexadecimal value</small>
        </div>
        <div class="flex-col" style="gap: 2px;">
            Background Colour 
            <div class="colour-container">
                <p-colorPicker ngDefaultControl [(ngModel)]="config.bgColour"></p-colorPicker>
                <input [(ngModel)]="config.bgColour" type="text" pInputText style="width: 100px;"> 
            </div>
            <small>Hexadecimal value</small>
        </div>
        <div class="flex-col" style="gap: 2px;">
            Button Colour 
            <div class="colour-container">
                <p-colorPicker ngDefaultControl [(ngModel)]="config.buttonColour"></p-colorPicker>
                <input [(ngModel)]="config.buttonColour" type="text" pInputText style="width: 100px;"> 
            </div>
            <small>Hexadecimal value</small>
        </div>
        <div class="flex-col" style="gap: 2px;">
            Button Text Colour 
            <div class="colour-container">
                <p-colorPicker ngDefaultControl [(ngModel)]="config.buttonTextColour"></p-colorPicker>
                <input [(ngModel)]="config.buttonTextColour" type="text" pInputText style="width: 100px;"> 
            </div>
            <small>Hexadecimal value</small>
        </div>
    </div>
    <div class="flex-row" style="align-self: flex-end;">
        <button pButton pRipple icon="pi pi-save" (click)="resetColours()" class="p-button-text p-button-plain" label="Reset Colours"
            style="align-self: flex-end;"></button>
        <button pButton pRipple icon="pi pi-save" (click)="saveConfig()" class="p-button-text p-button-plain" label="Save Settings"
            style="align-self: flex-end;"></button>
    </div>
    <div class="orient" *ngIf="user !== undefined">
        <div class="p-field field" style="width: 100%; display: flex; flex-direction: column;">
            <label for="firstNameId"><b style="color: #020202;">First Name</b></label>
            <input id="firstNameId" [(ngModel)]="user.firstName" type="text" pInputText placeholder="Enter your first name"> 
        </div>
        <div class="p-field field" style="width: 100%; display: flex; flex-direction: column;">
            <label for="lastNameId"><b style="color: #020202;">Last Name</b></label>
            <input id="lastNameId" [(ngModel)]="user.lastName" type="text" pInputText placeholder="Enter your last name"> 
        </div>
    </div>
    <button pButton pRipple icon="pi pi-save" (click)="saveUserDetails()" class="p-button-text p-button-plain" label="Save User Details"
            style="align-self: flex-end;"></button>
    <div class="orient" *ngIf="user !== undefined">
        <div class="p-field field" style="width: 100%; display: flex; flex-direction: column;">
            <span style="font-size: 18px; width: 100%; overflow: hidden;">{{user.email}}</span>
            <a [routerLink]="[]" (click)="changeEmailDialog.show()" style="color: #419154;"><b>Change email</b></a>
        </div>
        <div class="p-field field" style="width: 100%; display: flex; flex-direction: column;">
            <span style="font-size: 18px;">************</span>
            <a [routerLink]="[]" (click)="changePasswordDialog.show()" style="color: #419154;"><b>Change password</b></a>
        </div>
    </div>

    <div class="flex-col" *ngIf="clientData !== undefined">
        <h3>Company Info</h3>
        <span>{{clientData.name}}</span>
        <span>Invoice ID: {{clientData.id}}</span>
        <span>Plan: {{clientData.planName}}</span>
        <span>Available Views: {{clientData.planViews}} (plan), {{clientData.purchasedViews}} (purchased)</span>
        <span>Current Views: {{clientData.views}}</span>
        <span>Subscription ID: {{clientData.subId}}</span>
    </div>
</div>
<p-toast></p-toast>
<div style="position: absolute; bottom: 16px; right: 16px; display: flex; flex-direction: row; gap: 16px;" *ngIf="user !== undefined">
    <button pButton pRipple type="button" class="p-button-text p-button-plain" (click)="deleteAccountDialog.show()" label="Delete Account">
        <img src="assets/images/Trash.svg"/>
    </button>
    <button pButton pRipple type="button" class="p-button-text p-button-plain" (click)="signOut()" label="Logout">
        <img src="assets/images/Logout.svg"/>
    </button>
</div>

<dialog #changeEmailDialog style="width: 100%; height: 100%; position: absolute; top: 0;">
    <div class="home-center dialog" style="position: relative;" *ngIf="user !== undefined">
        <button pButton pRipple (click)="changeEmailDialog.close()" class="p-button-text p-button-plain" style="position: absolute; right: 0; top: 0;">
            <img src="assets/images/Cross.svg"/>
        </button>
        <h1 style="text-align: center;">Change Email</h1>
        <div class="p-field" style="width: 100%; display: flex; flex-direction: column;">
            <label for="newEmailId"><b style="color: #020202;">New Email</b></label>
            <input id="newEmailId" [(ngModel)]="user.email" type="text" pInputText placeholder="Enter your new email"> 
        </div>
        <div class="p-field" style="width: 100%; display: flex; flex-direction: column;">
            <label for="passwordId"><b style="color: #020202;">Password</b></label>
            <input id="passwordId" [(ngModel)]="password" type="password" pInputText placeholder="Enter your current password"> 
        </div>
        <a [routerLink]="[]" (click)="resetEmail()" style="color: #419154;"><b>Forgot password?</b></a>
        <button class="p-mb-2" pButton pRipple style="background-color: #FFC809; text-align: center; color: #042319; font-weight: 800;" 
                (click)="changeEmail()" aria-label="Update email" label="Update Email"
                [disabled]="!password || !user.email"></button>
    </div>
</dialog>

<dialog #changePasswordDialog style="width: 100%; height: 100%; position: absolute; top: 0;">
    <div class="home-center dialog" style="position: relative;" *ngIf="user !== undefined">
        <button pButton pRipple (click)="changePasswordDialog.close()" class="p-button-text p-button-plain" style="position: absolute; right: 0; top: 0;">
            <img src="assets/images/Cross.svg"/>
        </button>
        <h1 style="text-align: center;">Change Password</h1>
        <h4 style="text-align: center; color: #0D4131;">For security reasons, please first enter your current password </h4>
        <div class="p-field" style="width: 100%; display: flex; flex-direction: column;">
            <label for="currentPasswordId"><b style="color: #020202;">Current Password</b></label>
            <input id="currentPasswordId" [(ngModel)]="password" type="password" pInputText placeholder="Enter your current password"> 
        </div>
        <a [routerLink]="[]" (click)="resetEmail()" style="color: #419154;"><b>Forgot password?</b></a>
        <div class="p-field" style="width: 100%; display: flex; flex-direction: column;">
            <label for="newPasswordId"><b style="color: #020202;">New Password</b></label>
            <input id="newPasswordId" [(ngModel)]="newPassword" type="password" pInputText placeholder="Enter your new Password"> 
        </div>
        <div class="p-field" style="width: 100%; display: flex; flex-direction: column;">
            <label for="repeatPasswordId"><b style="color: #020202;">Repeat New Password</b></label>
            <input id="repeatPasswordId" [(ngModel)]="newPassword2" type="password" pInputText placeholder="Repeat your new Password"> 
        </div>
        <button class="p-mb-2" pButton pRipple style="background-color: #FFC809; text-align: center; color: #042319; font-weight: 800;" 
                (click)="changePassword()" aria-label="Update Password" label="Update Password" 
                [disabled]="!password || !newPassword || !newPassword2"></button>
    </div>
</dialog>

<dialog #deleteAccountDialog style="width: 100%; height: 100%; position: absolute; top: 0;">
    <div class="home-center dialog" style="position: relative;" *ngIf="user !== undefined">
        <button pButton pRipple (click)="deleteAccountDialog.close()" class="p-button-text p-button-plain" style="position: absolute; right: 0; top: 0;">
            <img src="assets/images/Cross.svg"/>
        </button>
        <div style="background-image: url(/assets/images/Circle.svg); object-fit: contain; background-size: contain; width: 66px; height: 66px; display: flex; 
                justify-content: center; margin: auto;">
            <img src="/assets/images/TrashOutline.svg" style="width: 40px; height: 40px; margin: auto;" />
        </div>
        <h1 style="text-align: center;">Are you sure you want to delete your account?</h1>
        <h4 style="text-align: center; color: #0D4131;">This action cannot be undone</h4>
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: space-between;">
            <button class="p-mb-2 p-button-outlined p-button-danger" pButton pRipple style="width: 45%; text-align: center; color: #042319; font-weight: 800; 
                border-color: red; border-width: 3px; color: red; border-radius: 12px;" 
                (click)="deleteAccount()" aria-label="Delete" label="Delete"></button>
            <button class="p-mb-2" pButton pRipple style="width: 45%; background-color: #FFC809; text-align: center; color: #042319; font-weight: 800; border-radius: 12px;" 
                (click)="deleteAccountDialog.close()" aria-label="Keep Active" label="Keep Active"></button>
        </div>
    </div>
</dialog>